import { getEffectiveProductTypeCatch } from '@components/filters-tray/FiltersTray';
import { ProductType } from '@pages/product-analyzer/Product';
import { getSubscriptionDetailsByProductType, SubscriptionDetail } from '@utils/AppSubscriptionUtils';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';
import { byFilterKey } from '@utils/pageConfig/Predicates/SelectedFiltersPredicates';
import { FilterKeys, SavedFilters } from '@utils/pageConfig/Types';

export const getClientSubscriptionMapping = (pagesConfig: PagesConfig) => {
  const subscriptionDetailsForRI: SubscriptionDetail = getSubscriptionDetailsByProductType(
    ProductType.PerformanceAnalyzer,
    pagesConfig,
  );

  const subscriptionDetailsForMarketPremium: SubscriptionDetail = getSubscriptionDetailsByProductType(
    ProductType.MarketPremium,
    pagesConfig,
  );

  const subscriptionDetailsForProducts: SubscriptionDetail = getSubscriptionDetailsByProductType(
    ProductType.ProductAnalyzer,
    pagesConfig,
  );

  const subscriptionDetailsForSellerInsights: SubscriptionDetail = getSubscriptionDetailsByProductType(
    ProductType.SellerInsights,
    pagesConfig,
  );

  const subscriptionDetailsForRetailKad: SubscriptionDetail = getSubscriptionDetailsByProductType(
    ProductType.RetailKad,
    pagesConfig,
  );

  return {
    [ProductType.PerformanceAnalyzer]: subscriptionDetailsForRI.currentClientId,
    [ProductType.MarketPremium]: subscriptionDetailsForMarketPremium.currentClientId,
    [ProductType.ProductAnalyzer]: subscriptionDetailsForProducts.currentClientId,
    [ProductType.SellerInsights]: subscriptionDetailsForSellerInsights.currentClientId,
    [ProductType.RetailKad]: subscriptionDetailsForRetailKad.currentClientId,
  };
};

export const filterNonSubscribedCountry = (
  currentSavedFilters: SavedFilters[],
  subscribedProductTypes: ProductType[],
  pagesConfig: PagesConfig,
) => {
  const currentProductType = getEffectiveProductTypeCatch(subscribedProductTypes, pagesConfig.pageName);

  const subscriptionDetailsForRI = getSubscriptionDetailsByProductType(currentProductType, pagesConfig);
  let subscriptionCountryList = subscriptionDetailsForRI.currentClientCountries.map((country) => country.name);

  let array: number[] = [];
  currentSavedFilters.forEach((element, index) => {
    const filterCountryList = element.filters.find(byFilterKey(FilterKeys.COUNTRY))?.options.map((c) => c.label);
    if (filterCountryList) {
      filterCountryList.forEach((f) => {
        if (!subscriptionCountryList.includes(f)) {
          array.push(index);
        }
      });
    }
  });

  const newSavedFilters = currentSavedFilters;
  for (let i = array.length - 1; i >= 0; i--) newSavedFilters.splice(array[i], 1);
  return newSavedFilters;
};
